import {Paper, styled} from "@mui/material";

export const NewRecipientContainer = styled(Paper)(() => {
    return {
        display: 'flex',
        alignItems: 'flex-start',
        max: '40rem',
        width: '100%',
        height: 'fit-content',
        flexDirection: 'column',

        gap: '1rem',
        padding: '1rem 1.5rem',
        borderRadius: '0.5rem'
    }
});

export const RecipientActionButtonContainer = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'right',
        width: '100%',

        '& .MuiButtonBase-root:first-of-type' : {
            marginRight: '1rem'
        }
    }
});